import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { currencyTypes } from 'utils/Constants'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { InputNumber } from 'primereact/inputnumber'
import { Checkbox } from "primereact/checkbox";
import Icons from '../../assets/icons'
import { useFileReader } from '../../hooks/useFileReader'

const AddCrModalContent = ({ handleClose, handleAdd, currentRate }) => {
    const { projectId } = useParams()
    const [saveSla] = useRequest()
    const { showToast } = useToast()
    const { crStatuses } = useSelector((state) => state.projectDetail)
		const [filesData, setFilesData, convert] = useFileReader()
    const [addForm, setAddForm] = useState({
        projectId: projectId,
        startDate: null,
        endDate: null,
        name: null,
        statusId: null,
        budget: null,
        currency: 'TL',
        monthlyManDay: null,
        isSingleInvoice: true
    })
  const [hour, setHour] = useState("");

  const dayToHour=(dayValue)=>{
    const hourValue=dayValue*8;
    setHour(hourValue.toString());
  };

 useEffect(() => {
    dayToHour(addForm.monthlyManDay)
 },[addForm.monthlyManDay])

    const handleChange = (e) => {
        if (e.name == 'monthlyManDay' && currentRate) {
            setAddForm(prev => ({ ...prev, [e.name]: e.value, budget:currentRate * e.value }))
        } else {
            setAddForm(prev => ({ ...prev, [e.name]: e.value }))
        }
    }

		const handleFiles = (e) => {
				convert(e.files)
		}

		const removeFile = (file) => {
			setFilesData((prev) => [...prev.filter((f) => f.fileName !== file.fileName)])
		}

    const handleSubmit = () => {
        if (!addForm.statusId) {
            showToast('Lütfen Durumun Seçin', 'error')
        }
        else if (!addForm.name) {
            showToast('Lütfen Ek Geliştirme Adını Girin', 'error')
        } else if (addForm.isSingleInvoice && !addForm.budget) {
            showToast('Fatura Kaydı Oluşturabilmek İçin Lütfen Bütçe Giriniz', 'error')
        } else if (filesData.length < 1) {
            showToast('Lütfen Dosya Ekleyiniz.', 'error')
        } else {
            const formData = new FormData();
            for (let key in addForm) {
              /* eslint-disable-next-line no-prototype-builtins */
              if (addForm.hasOwnProperty(key)) {
                formData.append(key, addForm[key]);
              }
            }
            filesData.forEach(v => {
              formData.append(`documents`, v.file);
            });

            saveSla('/ChangeRequests/AddChangeRequests', {
                method: 'POST',
                data: formData
            }).then(res => {
                if (res.data.ok) {
                    showToast('EK Geliştirme Oluşturuldu', 'success')
                    handleClose()
                    handleAdd()
                }
            })
        }
    }
    return (
        <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
            <div className="row">
                <div className='col-md-12'>
                    <div className='form-control'>
                        <input
                            placeholder='Ek Geliştirme Adı'
                            className='default-input'
                            type='text'
                            name='name'
                            onChange={(e) => handleChange(e.target)}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='col-md-6'>
                    <div className='form-control'>
                        <Calendar
                            dateFormat='dd/mm/yy'
                            placeholder='Başlangıç Tarihi'
                            name='startDate'
                            onChange={(e) => {
                                handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
                            }}
                        />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <Calendar
                            dateFormat='dd/mm/yy'
                            placeholder='Bitiş Tarihi'
                            name='endDate'
                            onChange={(e) => {
                                handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='col-md-6'>
                    <div className='form-control'>
                        <DefaultSelect
                            placeholder='Durum'
                            selectOptions={crStatuses.map(p => ({ ...p, name: 'statusId' }))}
                            handleChange={(e) => handleChange(e)}
                        />
                    </div>
                </div>
                <div className= {'col-md-3'}>
                    <div className='form-control'>
                        <input
                            placeholder='Adam/Gün'
                            className='default-input'
                            type='text'
                            name='monthlyManDay'
                            onChange={(e) =>{
                                // eslint-disable-next-line no-useless-escape
                                e.target.value = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
                                // eslint-disable-next-line no-useless-escape
                                handleChange({value:e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1'),name:e.target.name})
                            }}
                        />
                    </div>
                </div>
                {
                    <div className='col-md-3'>
                    <div className='form-control'>
                        <input
                            placeholder='Saat'
                            value={hour && `${hour} saat`}
                            className='default-input'
                            type='text'
                            name='dayToHour'
                            disabled
                        />
                    </div>
                </div>
                }
            </div>
            <div className="row">
                <div className='col-md-6'>
                    <div className='form-control'>
                        <InputNumber mode="decimal" value={addForm.budget} minFractionDigits={2} maxFractionDigits={2} placeholder='Bütçe' name='budget' onChange={(e) => handleChange({ name: 'budget', value: e.value })} />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='form-control'>
                        <DefaultSelect
                            placeholder='Para Birimi'
                            value={currencyTypes.find(c => c.value == addForm.currency)}
                            selectOptions={currencyTypes}
                            handleChange={(e) => handleChange(e)}
                        />
                    </div>
                </div>
            </div>
						<div className='row'>
							<div className='col-md-12'>
								<label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
									<span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>CR Talep Dokümanı yüklemek için tıklayınız</span>
								</label>
								<input
									type='file'
									name='files'
									multiple
									onChange={(e) => handleFiles(e.target)}
									id='file-uploader'
									className='filterTask-file-upload--form--row--item--file-uploader--input'
								/>
                <small style={{marginLeft: '10px'}}>CR Talep dokümanı template dosyasına Teams &gt; PM &gt; Files altından ulaşabilirsiniz.</small>
							</div>
							<div className='ml-4 w-100 mt-2 gap-3'>
								{filesData?.length > 0 &&
									filesData?.map((file, i) => (
										<div className='text-sm comment-fileList w-unset' key={i}>
											<div className='d-flex align-items-center'>{file?.fileName}</div>
											<Icons.delete
												onClick={() => {
													removeFile(file)
												}}
												size={16}
											/>
										</div>
									))}
							</div>
						</div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-control flex-row gap-2">
                        <Checkbox id='isSingleInvoice' checked={addForm.isSingleInvoice} onChange={() => setAddForm(prev => ({ ...prev, isSingleInvoice: !prev.isSingleInvoice }))} />
                        <label htmlFor="isSingleInvoice" className="form-control-label">Tek Faturalı</label>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-md-3">
                    <Button handleClick={handleSubmit} className='btn-success w-100 justify-content-center' title={'Ekle'} />
                </div>
                <div className="col-md-3">
                    <Button handleClick={handleClose} className='btn-danger-outline w-100 justify-content-center' title={'Vazgeç'} />
                </div>
            </div>
        </div>
    )
}
AddCrModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
}
export default AddCrModalContent

